module.exports = __webpack_public_path__ + "img/confirmation.c121258c.svg";